/*
 * @Author: your name
 * @Date: 2021-05-14 16:02:59
 * @LastEditTime: 2022-02-15 14:56:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/moduleDefine.js
 */
/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'
const routerComponents = {
  // indexCheck: () =>
  //   import(/* webpackChunkName: "qc-plan" */ './check/index.vue'),
  // indexCheckResult: () =>
  //   import(/* webpackChunkName: "qc-plan" */ './check-result/index.vue')
  myCheck: () => import('./myCheck/index.vue'),
  indexCheck: () => import('./check/index.vue'),
  mulcheck: () => import('./MulCheck/MulCheck.vue'),
  infocheck: () => import('./check-info/index.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/',
      component: BasicLayout,
      meta: {
        title: '质量检查',
        icon: 'chart'
      },
      children: [
        {
          path: 'ZKJC/MyZKJCListForTask',
          component: dynamicWrapper(
            ['qc-check/check'],
            routerComponents.myCheck
          ),
          meta: { title: '我的质控检查', noCache: true }
        },
        {
          path: 'ZKJC/ZKJCListForTask',
          component: dynamicWrapper(
            ['qc-check/check'],
            routerComponents.indexCheck
          ),
          meta: { title: '质控检查', noCache: true }
        },
        {
          // path: 'check-result',
          // component: dynamicWrapper(
          //   ['qc-check/check-result'],
          //   routerComponents.indexCheckResultRG
          // ),
          path: 'ZKJCJG/ZKJCJGList',
          component: dynamicWrapper(
            ['qc-check/check'],
            routerComponents.indexCheck
          ),
          meta: { title: '检查结果查询', noCache: true }
        },
        {
          path: 'MulCheck/MulCheck',
          component: dynamicWrapper(
            ['qc-check/check'],
            routerComponents.mulcheck
          ),
          meta: { title: '批量检查', noCache: true }
        },
        {
          path: '/ZKJC/MyCheck',
          component: dynamicWrapper(
            ['qc-check/check'],
            routerComponents.infocheck
          ),
          meta: { title: '我的受检信息', noCache: true }
        }
      ]
    }
  ]
}
